import { Breadcrumbs } from 'AbstractElements';
import UsersContain from 'Component/Learning/Users';

const UserList = () => {
    return (
        <>
            <Breadcrumbs mainTitle="Users List" parent="Users" title="Daftar User" />
            <UsersContain />
        </>
    );
};
export default UserList;